import { ApiService } from "./ApiService"

export class DashboardService {

    static uri = '/dashboard';

    static get({ params }) {
        return ApiService.get(`${this.uri}/summary`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static show({ id }) {
        return ApiService.get(`${this.uri}/show/${id}`);
    }
}